/* -------------------------------------------------------------------------- */
/* ---------------------------------- FRONT --------------------------------- */

// CSS
import "./scss/theme.scss";

// JS
import "./vendors/player/player.js"
import "./js/theme.js";